import React, { Fragment, useState } from "react";
import { connect } from "react-redux";
import TransferUsersForm from "./TransferUsersForm.js";
import TransferDevicesForm from "./TransferDevicesForm.js";
import Message from "../../../CommonData/Data/Message.js";

const Transfer = (props) => {

  const { currentProfile, handleClose, userId, organisationId, errorMessage } = props;
  const [isTransferUser, setIsTransferUser] = useState(false);

  const handleTransferTypeChange = () => {
    setIsTransferUser(!isTransferUser);
  };
  return (
    <Fragment>
      {errorMessage && (
        <Message
          type="danger"
          defaultMessage={errorMessage}
          baseClassName="alert"
        />
      )}
      <div className="form-group">
        <div className="row">
          <div className="col-md-12">
            <h5 className="mt-0 text-bold">Transfer</h5>
            <p>You can transfer devices or users based on the selection.</p>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-6">
            <div className="form-group">
              <ul className="form-unstyled-list form-status-list">
                <li
                  onClick={handleTransferTypeChange}
                  className={`form-status-item ${!isTransferUser ? "active" : ""}`}
                >
                  Device
                </li>&nbsp;&nbsp;
                <li
                  onClick={handleTransferTypeChange}
                  className={`form-status-item ${isTransferUser ? "active" : ""}`}
                >
                  User
                </li>
              </ul>
            </div>
          </div>
        </div>
        {isTransferUser ? (
          <TransferUsersForm
            userId={userId}
            organisationId={organisationId}
            handleClose={handleClose}
          />
        ) : (
          <TransferDevicesForm
            userId={userId}
            organisationId={organisationId}
            handleClose={handleClose}
          />
        )}
      </div>
    </Fragment>
  );
}

const mapStateToProps = (state) => ({
  currentProfile: state.login.currentProfile,
  errorMessage: state.userdetails.transferErrorMessage,

})
export default connect(mapStateToProps, null)(Transfer);
